import React, { useState, useEffect, useContext } from 'react'
import { NavLink } from 'react-router-dom'

import { GlobalContext } from 'core/contexts/global-context'

import AboutIcon from './icons/AboutIcon'
import ContactIcon from './icons/ContactIcon'
import DynamiteIcon from './icons/DynamiteIcon'
import ConversationsIcon from './icons/ConversationsIcon'
import MenuIcon from './icons/MenuIcon'
import PressIcon from './icons/PressIcon'
import ProjectsIcon from './icons/ProjectsIcon'

const Navigation = props => {
  const [open, setOpen] = useState(false)
  const { screenWidth } = useContext(GlobalContext)
  const [mobile, setMobile] = useState(false)
  const navNames = ['nav-one', 'nav-two']

  useEffect(() => {
    setMobile(screenWidth <= 830)
  }, [screenWidth])

  const isActive = (route, location) => {
    return location.pathname.slice(0, route.length) === route
  }

  const closeMenu = () => {
    setOpen(false)
  }

  return (
    <nav className={`navigation ${open ? 'is-open' : 'is-closed'}`}>
      <div className="navigation-closer" onClick={closeMenu}></div>
      <MenuIcon open={open} setOpen={setOpen} mobile={mobile} />
      {navData.map((nav, i) => (
        <ul key={navNames[i]} className={navNames[i]}>
          {nav.map((item, i) => {
            if (mobile && item.mobile === false) return null
            return (
              <li className="navigation-item" key={i}>
                <NavLink to={item.route} className="navigation-link" onClick={closeMenu}>
                  <item.Icon active={isActive(item.route, props.location)} />
                  {item.title}
                </NavLink>
              </li>
            )
          })}
        </ul>
      ))}
    </nav>
  )
}

const navData = [
  [
    {
      route: '/about/',
      title: 'About',
      Icon: AboutIcon
    },
    {
      route: '/projects/',
      title: 'Projects',
      Icon: ProjectsIcon
    },
    {
      route: '/contact/',
      title: 'Contact',
      Icon: ContactIcon
    }
  ],
  [
    {
      route: '/press/',
      title: 'Awards & Media',
      Icon: PressIcon
    },
    {
      route: '/conversations/',
      title: 'Openings',
      Icon: ConversationsIcon
    },
    {
      route: '/dynamite/',
      title: 'Dynamite',
      Icon: DynamiteIcon,
      mobile: false
    }
  ]
]

export default Navigation
